<template>
	<div>
		<top></top>
		<div class="container">
			<breadcrumb :url="url"></breadcrumb>
			<div class="goods flex jus-between">
				<div class="goods-left flex flex-column">
					<img :src="bannerImg" alt="" class="goods-img">
					<div class="goods-img-mini flex ali-cen jus-cen" >
						<img v-for="(item,index) in info.images" :src="item"  @mouseover="click(item,'bannerImg')" :key="index" alt="">
					</div>
				</div>
				<div class="goods-right">
					<div class="column" style="margin-top: -15px;color: #333;font-size: 20px;">
						产品名称：{{info.title}}
					</div>
					<div class="column flex" style="border: none;">
						<div style="margin-right: 100px;">
							商品编号：{{sku.sn}}
						</div>
						<div>产品型号：{{sku.model}}</div>
					</div>
					<div class="column">
						<div>产品规格：{{sku.goods_sku_text}}</div>
					</div>

					<div class="column flex">
						<div class="orange">价值:<span style="font-size: 14px;text-decoration:line-through;">¥{{info.original_price}}</span></div>
                        <div>兑换价格: <span class="orange"> {{info.price}}</span></div>
						<div>已兑换: <span class="orange"> {{info.sales}}</span></div>

					</div>
					<div class="column flex" style="border: none;height: auto;" >
						<div class="flex ali-cen flex-wrap">
							<div class="orange" style="margin-right: 10px;">套餐类型</div>
							<div v-for="(item,index) in info.sku_price" @click="clickSku(item.id)" :key="index" :class="sku.id == item.id ? 'btn-true btns' : 'btns' ">{{item.goods_sku_text}}</div>
						</div>
					</div>
					<div class="column flex" style="border: none;">
						<div class="">数量：</div>
						<!-- <div> <el-input-number v-model="num" @change="handleChange" :min="1" :max="10" label="描述文字"></el-input-number></div> -->
						<div>库存：{{info.stock}}件</div>
					</div>

					<div class="column">
						<div>产品有效期：24个月</div>
					</div>
					<!-- <div class="flex ali-cen" style="margin-top: 30px;">
						<el-button type="primary" @click="jumpConfirm" :disabled = "stocks === 0">立即购买</el-button>
						<el-button type="warning" @click="addCart" :disabled = "stocks === 0">加入购物车</el-button>
						<el-button type="warning" plain @click="addFavorite(info.id)">加入收藏夹</el-button>

					</div> -->
                    <div class="column" style="border-bottom:none">
						 <el-button type="primary" @click="jumpConfirm">立即兑换</el-button>
					</div>

				</div>
			</div>
			<div class="goodsIndo_">
				<div class="column" style="border: none;">
					<div style="padding: 0 10px;border-left: 5px solid #FF6701;" :class="{'column-true' :contentId == 1 }" @click="click(1,'contentId')">产品详情</div>
					<div style="padding: 0 10px;" :class="{'column-true' :contentId == 2 }" @click="click(2,'contentId')">产品注册证</div>
				</div>
				<div class="flex">
					<div class="info-con">
						<div class="info-con-top">
							<div class="column" style="border: none;">
								产品名称：{{info.title}}
							</div>
							<div class="column" style="border: none;">
								<div>产品品牌：康买系列</div>
								<div>型号规格：000</div>
								<div>包装规格：000</div>
							</div>
						</div>
						<div class="info-con-view">
							<div v-html="content"></div>
						</div>
					</div>
					<div class="like">
						<div class="blue" style="margin-top: -30px;width: 200px; text-align: center;">
							猜你喜欢
						</div>
						<div class="like-img flex flex-column">
							<div  class="like-img-item" @click="clickId(item.id)" v-for="(item,index) in list" :key="index">
								<img :src="'https://app.comeandbuy.com.cn/'+item.image"  alt="" >
								<div></div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		<bottom></bottom>
	</div>

</template>

<script>
  import top from '../../components/top.vue'
  import breadcrumb from '../../components/breadcrumb.vue'
  import bottom from '../../components/bottom.vue'
  import {detail,simplegoodsset,goodsFavorite,scoreSkuDetail} from '@/api/index.js'
  import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
  if (localStorage.getItem("userInfo")) {
    var token = JSON.parse(localStorage.getItem("userInfo")).token;
    var header = {
        "Content-Type": "application/json",
        token: token,
        platform: "H5"
    };
}
  export default {
    data() {
      return {
		url:[{name:'详情页',url:'/type'}],
		num:'1',
		id:'',
		contentId:'1',  //富文本详情切换
		sku:{},
		info:{},
		bannerImg:'',
		content:'', //富文本详情
        list:'',
        stocks:0,
		cate:''
      }
    },
	beforeCreate () {
	    document.querySelector('body').setAttribute('style', 'background:#f5f5f5')

	},
	created() {
		this.id = this.$route.query.id
		this.detail()
		this.lists()
	},
	methods:{
		...mapActions(['addCartGoods']),
		detail(){
			scoreSkuDetail({id:this.id}).then(res => {
                console.log(res);
				if(res.code == 1){
                    let g_image = res.data.image;
                    res.data.images.unshift(g_image);
                    this.info = res.data
                    this.stocks = res.data.stock
                    //console.log(res.data.stock);
                    this.sku = res.data.sku_price[0]
                    this.content =  res.data.content
					this.bannerImg = res.data.images[0]
					this.cate = res.data.category_ids
                    console.log(this.info)
                    console.log(this.content);

				}

			})
		},
		clickId(e){
			this.id = e
			this.detail()
		},
		lists(){
			simplegoodsset({cate:this.cate}).then(res => {
				if(res.code == 1){
					 this.list = res.data.slice(0, 6);
				}
			})
		},
		addCart(){
			let obj = [{
				goods_id: this.info.id,
				goods_num: this.num,
				goods_price: this.sku.price,
				sku_price_id: this.sku.id
			}]
			this.addCartGoods({goods_list:obj,from:'goods'}).then(res => {
				console.log(res,'res.sss')
			}).catch(err => {
				console.log('errrrrrrrrrrrr',err)
			})
		},
		clickSku(e){
			console.log(e,'eee')
			this.info.sku_price.forEach(i => {
				if(i.id == e){
					this.sku = i
				}
			})
		},
		// jump(url,value = {}){
		// 	console.log(url,'ss')
		// 	this.$router.push({name:'confrim'})
		// },
		jump(path, query = {}) {
			if(path == 'confirm'){
				if(!localStorage.getItem('userInfo')){
					return
				}
			}
			this.$router.push({
				path: path,
				query: query
			});
		},
		jumpConfirm(){
			if(!localStorage.getItem('userInfo')){
				this.$message.error('您还没有登录，请先登录')
				return
            }

            let obj = [];
            obj.push({
                    goods_id:this.sku.goods_id,
					goods_num:this.num,
					goods_price:this.sku.price,
                    sku_price_id:this.sku.id,
                    // order_type: "score",
            })

            console.log(obj);
			this.$router.push({
				name: 'scoreConfirm',
				query: {goods:JSON.stringify(obj),from:'goods'}
			});
            this.$router.go(0)
		},
		click(e,type){
			this[type] = e
			if(type == 'contentId'){
				if(e == 1){
					this.content = this.info.content
				}else{
                    this.content = this.info.reg_content
                    console.log(this.content);
				}
			}
        },
        //加入收藏
        addFavorite(id){
            console.log(id);
        goodsFavorite({goods_id:id},header).then(res=>{
        if(res.code !==1){
            return this.$message.error(res.msg)
        }
        return this.$message.success(res.msg)
        })
        }
	},
	components:{
		top,
		breadcrumb,
		bottom
	}
  }
</script>

<style lang="less" scoped>
.goods{
	.goods-left{

		.goods-img{
			width: 478px;
			height: 420px;
		}
		.goods-img-mini{
			width: 478px;
			margin-top: 24px;
			img{
				width: 58px;
				height: 58px;
				margin-right: 10px;
			}
		}
	}
	.goods-right{
		width: 632px;
	}

}
.column{
	height: 50px;
	display: flex;
	align-items: center;
	font-size: 18px;
	border-bottom: solid 1px #D8D8D8;
    color: #666;

	div{
		margin-right: 50px;
	}
	.column-true{
		font-size: 26rpx;
		color: #0097FE;
	}
}
.goodsIndo_{
    width: 100%;
}
.info-con{
	width: 995px;
	.info-con-top{
		padding:0 20px;
		border: solid 1px #D8D8D8;
	}
	.info-con-view{
		padding: 30px;
		border: solid 1px #D8D8D8;
		border-top:none ;

	}
}
.like{
	width: 250px;
	margin-left: 10px;
	.like-img{
		position: relative;
		.like-img-item{
			img{
				width: 224px;
				height: 179px;
				margin-top: 13px;
			}
			div{
				position: absolute;
				bottom: 10px;
				left: 10px;
				// color: #333;
			}
		}

	}
}
.btns{
	height: 30px;
    padding: 0 10px;
    line-height: 30px;
	border: solid 1px #979797;
	color: #979797;
	font-size: 14px;
	margin-right: 10px !important;
	margin: 10px 0 0 0;
}
.btn-true{
	border: solid 1px #FF6701;
	color: #FF6701;
}


</style>



// WEBPACK FOOTER //
// src/views/index/goods_score_info.vue